<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <h2>
                Blog Triidy
            </h2>
            <h4>
                Inspirate, emprende, vende y crece.
            </h4>
            <p>
                En el mundo del comercio electrónico cada día surgen nuevas tendencias, tecnologías y herramientas que permiten que las marcas tengan una mayor cantidad de ventas y que los usuarios mejoren su experiencia de compra, en Triidy te contamos todo lo que debes
                saber para mantenerte actualizado acerca de los siguientes temas:
            </p>
            <button class="btn2">Atención al cliente</button>
            <button class="btn2">Drop Shipping</button>
            <button class="btn2">Tiendas Online</button>
            <button class="btn2">Redes Sociales</button>
            <button class="btn2">Whatsapp</button>
            <button class="btn2">Marketing</button>
            <button class="btn2">Colombia</button>
            <button class="btn2">Marcas afiliadas</button>
            <button class="btn2">Historias</button>
        </div>
        <div class="col right">
            <carousel class="carrou navegador" [overflowCellsLimit]="0" [loop]="true" [cellWidth]="10" [cellsToShow]="2" [autoplay]="true">
                <div class="carousel-cell" *ngFor="let ben of Principales">
                    <div class="card2">
                        <div class="contimg">
                            <img class="image" [src]="ben.imagen" alt="">
                        </div>
                        <div class="contentext">
                            <h3>{{ ben.titulo }}</h3>
                            <p>{{ ben.parrafo }}</p>
                            <p><span class="fech">15 Nov 2020</span><a class="see" routerLink="/blog/detalle">Ver
                                    artículo<i class="fas fa-arrow-right"></i></a></p>
                        </div>
                    </div>
                </div>
            </carousel>
            <div id="carouselExampleControls2" class="carousel slide mobile" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item" *ngFor="let ben of Principales" [ngClass]="{'active':ben.id === 1}">
                        <div class="card2">
                            <div class="contimg">
                                <img class="image" [src]="ben.imagen" alt="">
                            </div>
                            <div class="contentext">
                                <h3>{{ ben.titulo }}</h3>
                                <p>{{ ben.parrafo }}</p>
                                <p><span class="fech">15 Nov 2020</span><a class="see" routerLink="/blog/detalle">Ver
                                        artículo<i class="fas fa-arrow-right"></i></a></p>
                            </div>
                        </div>
                    </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls2" role="button" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls2" role="button" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </a>
            </div>
        </div>
    </div>
    <div class="row secc2">
        <p>Registrate para recibir las últimas noticias y novedades acerca de Triidy.</p>
        <p class="intros">
            <input class="inputs" type="text" id="nombre" required />
            <label for="nombre" alt="Nombres" placeholder="Nombres"></label>
        </p>
        <p class="intros">
            <input class="inputs" type="email" id="email" required />
            <label for="email" alt="Correo electrónico" placeholder="Correo electrónico"></label>
        </p>
        <button class="btn">Suscríbete</button>
    </div>
    <div class="row secc3">
        <div class="col left">
            <div class="row temas" id="temas">
                <div class="col-6 blogs" *ngFor="let ben of Listado">
                    <div class="card2">
                        <div class="contimg">
                            <img class="image" [src]="ben.imagen" alt="">
                        </div>
                        <div class="contentext">
                            <h3>{{ ben.titulo }}</h3>
                            <p class="fech"><span>Marketing</span>15 Nov 2020</p>
                            <p>{{ ben.parrafo }}</p>
                            <p><a class="see" routerLink="/blog/detalle">Ver artículo<i
                                        class="fas fa-arrow-right"></i></a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col right navegador">
            <div class="boxx" id="cajaSus">
                <h3>Únete a Triidy</h3>
                <p>Recibe consejos sobre comercio electrónico, marketing online, redes sociales, negocios y mucho más.
                </p>
                <p class="intros">
                    <input class="inputs" type="text" id="nombre2" required />
                    <label for="nombre" alt="Nombres" placeholder="Nombres"></label>
                </p>
                <p class="intros">
                    <input class="inputs" type="email" id="email2" required />
                    <label for="email" alt="Correo electrónico" placeholder="Correo electrónico"></label>
                </p>
                <button class="btn">Suscríbete</button>
            </div>
        </div>
    </div>
    <div class="row secc4">
        <h2>Gestiona y organiza tu tienda virtual desde tu computador o desde tu celular.</h2>
        <button class="btn">Registrate Ahora</button>
    </div>
    <div class="row secc5">
        <p>Con el apoyo y acompañamiento de:</p>
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Acompa12-new.png" alt="">
    </div>
</div>